import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NePdfSvg } from './NePdfSvg'

export const NePdfIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NePdfSvg} {...props} />
}
